import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdmissionsOverviewComponent } from './admissions-overview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: AdmissionsOverviewComponent,
    data: {
      title: "Mentoring Advising",
      breadcrumb: "Mentoring Advising"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class AdmissionsOverviewRoutingModule { }